import React from 'react'
import styled from 'styled-components'
import {LinkProps} from 'lib/ui/link'
import {useLinkStyle} from 'lib/ui/link/style'

type Props = LinkProps & {
  to: string
  download?: boolean
}

export const AbsoluteLink = React.forwardRef(
  (props: Props, ref: React.Ref<any>) => {
    const target = props.newTab ? '_blank' : '_self'
    const rel = props.newTab ? 'noopener noreferrer' : ''
    const style = useLinkStyle(props)

    if (props.disabled) {
      return (
        <DisabledLink
          onClick={(e) => e.preventDefault()}
          ref={ref}
          href={props.to}
          className={props.className}
          aria-label={props['aria-label']}
          disableStyles={props.disableStyles}
          color={style.color}
        >
          {props.children}
        </DisabledLink>
      )
    }

    return (
      <StyledAnchor
        onClick={props.onClick}
        ref={ref}
        href={props.to}
        underline={style.underline}
        color={style.color}
        className={props.className}
        target={target}
        rel={rel}
        aria-label={props['aria-label']}
        download={props.download}
      >
        {props.children}
      </StyledAnchor>
    )
  },
)

const StyledAnchor = styled.a<{
  underline?: boolean
  color: string
}>`
  font-size: inherit;
  color: ${(props) => props.color};
  &:hover {
    text-decoration: ${(props) =>
      props.underline ? 'underline' : 'none'} !important;
  }
`

const DisabledLink = styled(StyledAnchor)<{
  disableStyles?: boolean
}>`
  opacity: ${(props) => (props.disableStyles ? 1 : 0.8)};
  cursor: not-allowed;
`
